__turbopack_context__.v({
  "answer": "QuickAnswers-module__oYG3dW__answer",
  "content": "QuickAnswers-module__oYG3dW__content",
  "enterCTA": "QuickAnswers-module__oYG3dW__enterCTA",
  "headingContainer": "QuickAnswers-module__oYG3dW__headingContainer",
  "introHeading": "QuickAnswers-module__oYG3dW__introHeading",
  "mainContent": "QuickAnswers-module__oYG3dW__mainContent",
  "qAndAItem": "QuickAnswers-module__oYG3dW__qAndAItem",
  "questionExpandyButton": "QuickAnswers-module__oYG3dW__questionExpandyButton",
  "questionExpandyButtonExpanded": "QuickAnswers-module__oYG3dW__questionExpandyButtonExpanded",
  "questionWrapper": "QuickAnswers-module__oYG3dW__questionWrapper",
  "questionsAndAnswers": "QuickAnswers-module__oYG3dW__questionsAndAnswers",
  "toggleButtons": "QuickAnswers-module__oYG3dW__toggleButtons",
});
